import React from 'react';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import TableContainer from '@material-ui/core/TableContainer';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core';
import Modal from '@material-ui/core/Modal';
import { EXPENSE_FILE_MESSAGES } from '../../../constants/messages';

const useStyles = makeStyles((theme) => ({
  tableContainer: {
    width: '60%',
    maxHeight: '80%',
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    marginTop: theme.spacing(2)
  },
  tableHeader: {
    backgroundColor: theme.palette.primary.main,
  },
  tableHeaderContent: {
    color: theme.palette.common.white,
    fontWeight: 700,
  },
  tableRow: {
    '&:nth-child(even)': {
      backgroundColor: theme.palette.grey[200],
    }
  },
  tableData: {
    color: theme.palette.red,
    fontWeight: 500
  },
  closeRow: {
    cursor: 'pointer',
    backgroundColor: theme.palette.primary.main,
  },
  closeRowContent: {
    fontWeight: 700,
    color: theme.palette.common.white,
  }
}));



const ExpenseValidationModal = ({ errors, handleClose}) => {
  const styles = useStyles();

  return (
    <Modal
      open={true}
      onClose={handleClose}
    >
      <TableContainer className={styles.tableContainer} component={Paper}>
        <Table size="small">
          <TableHead>
            <TableRow className={styles.tableHeader}>
              <TableCell
                className={styles.tableHeaderContent}
                component="th"
                align="center"
                colSpan={2}
              >
                { EXPENSE_FILE_MESSAGES.checkError }
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody >
            {errors.map(validationError => {
              return (
                <TableRow className={styles.tableRow} key={validationError}>
                  <TableCell className={styles.tableData} >{validationError}</TableCell>
                </TableRow>
              )
            })}
            <TableRow onClick={handleClose} className={styles.closeRow}>
              <TableCell className={styles.closeRowContent} align="center" colSpan={2}>Close</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Modal>
  );
};

export default ExpenseValidationModal;
